import { render } from "./MobileMenuDestinations.vue?vue&type=template&id=3fa731de"
import script from "./MobileMenuDestinations.vue?vue&type=script&lang=js"
export * from "./MobileMenuDestinations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__